import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const config = {
  apiKey: "AIzaSyD0exME3UIdqhpUy1d6AJ_Q6iQ1IrMtgEk",
  authDomain: "tissyegabriel.firebaseapp.com",
  projectId: "tissyegabriel",
  storageBucket: "tissyegabriel.firebasestorage.app",
  messagingSenderId: "48713903888",
  appId: "1:48713903888:web:7f29c4d137889e841cbf95",
  measurementId: "G-RMXM5219SL",
  databaseURL: "https://tissyegabriel-default-rtdb.firebaseio.com/"
};

const app = initializeApp(config);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
